export const LexxApplication = {
  XTEAM: "x-team",
  XADMIN: "x-admin",
  ALL: "all"
};
